import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { SessionService } from 'src/app/shared/services/session.service';
import { PromoCodeDiscountType } from 'src/app/shared/models/promo-code-discount-type.enum';
import { PromoCodeService } from '../../../services/promo-code.service';
import { PromoCode } from '../../../models/promo-code';

@Component({
    selector: 'promo-code-edit-modal',
    templateUrl: './promo-code-edit-modal.component.html',
    styleUrls: ['./promo-code-edit-modal.component.scss'],
    standalone: false
})
export class PromoCodeEditModalComponent extends BaseModalComponent implements OnInit {
  promoCode: PromoCode;
  DiscountType = PromoCodeDiscountType;
  public form: FormGroup = new FormGroup({
    code: new FormControl('', {
      validators: Validators.required
    }),
    discountType: new FormControl(PromoCodeDiscountType.Percentage, {
      validators: Validators.required
    }),
    discountAmount: new FormControl('', {
      validators: Validators.required
    }),
    startDate: new FormControl(null, {
      validators: Validators.required
    }),
    endDate: new FormControl(null, {
      validators: Validators.required
    }),
    usageLimit: new FormControl(null),
    currentUsageCount: new FormControl(0),
    isActive: new FormControl(true)
  });

  constructor(
    private promoCodeService: PromoCodeService,
    protected sessionService: SessionService,
    public dialogRef: MatDialogRef<PromoCodeEditModalComponent>
  ) {
    super();
  }

  ngOnInit() {
    if (this.promoCode) {
      this.form.patchValue({
        code: this.promoCode.code,
        discountType: this.promoCode.discountType,
        discountAmount: this.promoCode.discountAmount,
        startDate: this.promoCode.startDate,
        endDate: this.promoCode.endDate,
        usageLimit: this.promoCode.usageLimit,
        currentUsageCount: this.promoCode.currentUsageCount,
        isActive: this.promoCode.isActive
      });
    }
  }

  submit({value, valid}) {
    if (valid) {
      this.isLoading = true;
      value.id = this.promoCode.id;
      value.organizationId = this.sessionService.getUser().organizationId;
      value.lastEditedBy = this.sessionService.getUserId();

      this.promoCodeService.update(this.promoCode.id, value).subscribe({
        next: (result) => {
          this.dialogRef.close('save');
        },
        error: (error) => {
          console.error(error);
          this.isLoading = false;
          this.setError(error, this.form);
        },
        complete: () => this.isLoading = false
      });
    }
  }
}
